import * as React from "react";

import "./Field.scss";
import {Button, Icon, icons} from "@vebox/etui-core";
import {Buttons} from "../../../../components/buttons/Buttons";
import {Display} from "../../../../components/Display";
import {themeDefaultValues} from "../../../../index";

export enum FieldEventType {
    EDIT,
    APPLY,
    CANCEL,
}

export interface FieldEvent {
    type: FieldEventType;
}

interface FieldProps {
    fieldName?: string | JSX.Element;
    editing?: boolean;
    valid?: boolean;
    onChange?: (event: FieldEvent) => void;
    editable?: boolean;
    className?: string;
    showName?: boolean;
}

export const Field: React.FunctionComponent<FieldProps> = (props) => {

    const triggerNewEvent = (eventType: FieldEventType) => {
        if (!props.onChange) {
            return undefined;
        }
        return (_) => props.onChange({
            type: eventType,
        });
    };

    return (
        <div className={"Field" + (props.className ? " " + props.className : "")}>
            <div className={"left"}>
                <Display isVisible={props.showName !== false}>
                    <div className={"field-name"}>
                        {typeof props.fieldName === "string"
                            ? <p>{props.fieldName}: </p>
                            : props.fieldName
                        }
                    </div>
                </Display>
                {props.children}
            </div>
            <Display isVisible={props.editable !== false}>
                <div className={"actions"}>
                    <Display isVisible={!props.editing}>
                        <Buttons.ComponentButton
                            frontComponent={
                                <span className="material-icons-outlined">mode_edit</span>
                            }
                            onClick={triggerNewEvent(FieldEventType.EDIT)}
                        />
                    </Display>
                    <Display isVisible={props.editing}>
                        <Buttons.ComponentButton
                            frontComponent={
                                <Icon glyph={icons.CLOSE}/>
                            }
                            onClick={triggerNewEvent(FieldEventType.CANCEL)}
                        />
                        <Display isVisible={props.valid}>
                            <Buttons.ComponentButton
                                frontComponent={
                                    <span className="material-icons-outlined">done</span>
                                }
                                onClick={triggerNewEvent(FieldEventType.APPLY)}
                            />
                        </Display>
                    </Display>
                </div>
            </Display>
        </div>
    );
};